var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuzzleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.625 8.74998C12.9119 7.33712 13.6784 6.06689 14.7947 5.15451C15.9109 4.24213 17.3083 3.74371 18.75 3.74371C20.1917 3.74371 21.5891 4.24213 22.7053 5.15451C23.8216 6.06689 24.5881 7.33712 24.875 8.74998H32.5V17.5C33.8261 17.5 35.0979 18.0268 36.0355 18.9644C36.9732 19.9021 37.5 21.1739 37.5 22.5C37.5 23.8261 36.9732 25.0978 36.0355 26.0355C35.0979 26.9732 33.8261 27.5 32.5 27.5V35H22.5V33.75C22.5 32.7554 22.1049 31.8016 21.4017 31.0983C20.6984 30.3951 19.7446 30 18.75 30C17.7554 30 16.8016 30.3951 16.0983 31.0983C15.3951 31.8016 15 32.7554 15 33.75V35H5V22.5H10C10.663 22.5 11.2989 22.2366 11.7678 21.7677C12.2366 21.2989 12.5 20.663 12.5 20C12.5 19.3369 12.2366 18.7011 11.7678 18.2322C11.2989 17.7634 10.663 17.5 10 17.5H5V8.74998H12.625Z",
    fill: "#20C997"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleIcon);
export default __webpack_public_path__ + "static/media/puzzle-icon.7170a5c40dbd78f6510a18d121774d33.svg";
export { ForwardRef as ReactComponent };